import { darken, lighten } from "polished";
import { createGlobalStyle } from "styled-components";
export const GlobalStyle = createGlobalStyle`
    

    /*! destyle.css v1.0.11 | MIT License | https://github.com/nicolas-cusan/destyle.css */

/* Reset box-model
   ========================================================================== */

  * {
    box-sizing: border-box;
  }
  
  ::before,
  ::after {
    box-sizing: inherit;
  }
  
  /* Document
     ========================================================================== */
  
  /**
   * 1. Correct the line height in all browsers.
   * 2. Prevent adjustments of font size after orientation changes in iOS.
   * 3. Remove gray overlay on links for iOS.
   */
    
    html {
        line-height: 1.15; /* 1 */
        -webkit-text-size-adjust: 100%; /* 2 */
        -webkit-tap-highlight-color: transparent; /* 3*/
        height: 100%; 
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        user-select: none;
    }
    
    /* Sections
     ========================================================================== */
    
    /**
   * Remove the margin in all browsers.
   */
    
    body {
    margin: 0;
    color: ${(props) => props.theme.color.text};
    background-color: ${(props) => props.theme.color.base};
  }
  
  /**
   * Render the main element consistently in IE.
   */
  
  main {
    display: block;
  }
  
  /* Vertical rhythm
     ========================================================================== */
  
  p,
  table,
  blockquote,
  address,
  pre,
  iframe,
  form,
  figure,
  dl {
    margin: 0;
  }
  
  /* Headings
     ========================================================================== */
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: 0;
  }
  
  /* Lists (enumeration)
     ========================================================================== */
  
  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  
  /* Lists (definition)
     ========================================================================== */
  
  dt {
    font-weight: bold;
  }
  
  dd {
    margin-left: 0;
  }
  
  /* Grouping content
     ========================================================================== */
  
  /**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */
  
  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
    border: 0;
    margin: 0;
    clear: both;
    color: inherit;
    border-top: 1px solid ${({ theme }) => theme.color.accent2}; 
  }
  
  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd em font sizing in all browsers.
   */
  
  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: inherit; /* 2 */
  }
  
  address {
    font-style: inherit;
  }
  
  /* Text-level semantics
     ========================================================================== */
  
  /**
   * Remove the gray background on active links in IE 10.
   */
  
  a {
    background-color: transparent;
    text-decoration: none;
    color: inherit;
  }
  
  /**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */
  
  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }
  
  /**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */
  
  b,
  strong {
    font-weight: bolder;
  }
  
  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd em font sizing in all browsers.
   */
  
  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: inherit; /* 2 */
  }
  
  /**
   * Add the correct font size in all browsers.
   */
  
  small {
    font-size: 80%;
  }
  
  /**
   * Prevent sub and sup elements from affecting the line height in
   * all browsers.
   */
  
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  
  sub {
    bottom: -0.25em;
  }
  
  sup {
    top: -0.5em;
  }
  
  /* Embedded content
     ========================================================================== */
  
  /**
   * Remove the border on images inside links in IE 10.
   */
  
  img {
    border-style: none;
    vertical-align: bottom;
  }
  
  embed,
  object,
  iframe {
    border: 0;
    vertical-align: bottom;
  }
  
  /* Forms
     ========================================================================== */
  
  /**
   * Reset form fields to make them styleable
   * 1. Reset radio and checkbox to preserve their look in iOS.
   */
  
  button,
  .btn,
  input,
  optgroup,
  select,
  textarea {
    -webkit-appearance: none;
    appearance: none;
    vertical-align: middle;
    color: inherit;
    font: inherit;
    border: 0;
    background: ${({theme}) => theme.color.base_contrast};
    padding: 0;
    margin: 0;
    outline: 0;
    border-radius: 0;
    text-align: inherit;
  }
  button::-moz-focus-inner {
    border: 0;
  }

input, textarea {
  border: 1px solid ${({ theme }) => theme.color.accent2};
  padding:  ${({ theme }) => theme.spacing(1.5)};
  border-radius: 4px;
  transition: border 0.2s, box-shadow 0.3s;

  &:focus {
    border-color: ${({ theme }) => theme.color.highlight};
    box-shadow: 0px 4px 11px -3px rgba(0, 0, 0, 0.25);
  }

  &:hover:not(:focus):not(::disabled) {
    border-color: ${({ theme }) => theme.color.accent3};
  }
}

input:disabled {
    color: ${({theme}) => theme.color.accent2};
}
  
  [type='checkbox'] {
    /* 1 */
    -webkit-appearance: checkbox;
    appearance: checkbox;
  }
  
  [type='radio'] {
    /* 1 */
    -webkit-appearance: radio;
    appearance: radio;
  }

  button:not(.react-datepicker__navigation, .react-datepicker__close-icon), .btn {
    padding: ${({ theme }) => theme.spacing(1.5)} ${({ theme }) => theme.spacing(2)};
    background-color: ${({ theme }) => theme.color.accent1};
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.color.accent1};

    transition : color 0.2s, background-color 0.2s, border 0.2s;

    &:not([disabled]):hover {
      background-color:  ${({ theme }) => darken(0.05, theme.color.accent1)};
      border: 1px solid ${({ theme }) => darken(0.05, theme.color.accent1)};
    }

    &:focus {
      box-shadow:0px 1px 4px 0px ${({ theme }) => theme.color.accent4};
      &:hover {
        border: 1px solid ${({ theme }) => darken(0.05, theme.color.highlight)};
      }
    }

    &.primary {
      border: 1px solid ${({ theme }) => theme.color.highlight};
      background-color:  ${({ theme }) => theme.color.highlight};
      color: ${({ theme }) => theme.color.base_contrast};
      &:hover {
        background-color:  ${({ theme }) => darken(0.05, theme.color.highlight)};
        border: 1px solid ${({ theme }) => darken(0.05, theme.color.highlight)};
      }
      &:focus {
        box-shadow:0px 5px 15px -5px ${({ theme }) => theme.color.highlight};
      }
    }

    &.secondary {
      border: 1px solid ${({ theme }) => theme.color.accent1};
      background-color:  ${({ theme }) => theme.color.base};
    }

    &.tertiary {
      border: 1px solid ${({ theme }) => theme.color.accent2};
      background-color:  ${({ theme }) => theme.color.base_contrast};
      &:hover {
        border: 1px solid ${({ theme }) => darken(0.05, theme.color.accent3)};
      }
    }

    &.danger {
      border: 1px solid ${({ theme }) => theme.color.danger};
      background-color:  ${({ theme }) => theme.color.danger};
      color: white;
    }

    &[disabled] {
      color: ${({ theme }) => theme.color.accent3};
    }
  }

  /**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */
  
  button,
  input {
    /* 1 */
    overflow: visible;
  }
  
  /**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */
  
  button,
  select {
    /* 1 */
    text-transform: none;
  }
  
  /**
   * Correct the inability to style clickable types in iOS and Safari.
   */
  
  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
  }
  
  button[disabled],
  [type='button'][disabled],
  [type='reset'][disabled],
  [type='submit'][disabled] {
    cursor: default;
  }
  
  /**
   * Remove the inner border and padding in Firefox.
   */
  
  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  
  /**
   * Restore the focus styles unset by the previous rule.
   */
  
  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  
  /**
   * Reset to invisible
   */
  
  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
    min-width: 0;
  }
  
  /**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from fieldset elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    fieldset elements in all browsers.
   */
  
  legend {
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }
  
  /**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */
  
  progress {
    vertical-align: baseline;
  }
  
  /**
   * Remove the default vertical scrollbar in IE 10+.
   */
  
  textarea {
    overflow: auto;
  }
  
  /**
   * 1. Remove the padding in IE 10.
   */
  
  [type='checkbox'],
  [type='radio'] {
    padding: 0; /* 1 */
  }
  
  /**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */
  
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  
  /**
   * 1. Correct the outline style in Safari.
   */
  
  [type='search'] {
    outline-offset: -2px; /* 1 */
  }
  
  /**
   * Remove the inner padding in Chrome and Safari on macOS.
   */
  
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  
  /**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to inherit in Safari.
   */
  
  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }
  
  /**
   * Clickable labels
   */
  
  label[for] {
    cursor: pointer;
  }
  
  /* Interactive
     ========================================================================== */
  
  /*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */
  
  details {
    display: block;
  }
  
  /*
   * Add the correct display in all browsers.
   */
  
  summary {
    display: list-item;
  }
  
  /* Table
     ========================================================================== */
  
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  
  caption {
    text-align: left;
  }
  
  td,
  th {
    vertical-align: top;
  }
  
  th {
    text-align: left;
    font-weight: bold;
  }
  
  /* Misc
     ========================================================================== */
  
  /**
   * Add the correct display in IE 10+.
   */
  
  template {
    display: none;
  }
  
  /**
   * Add the correct display in IE 10.
   */
  
  [hidden] {
    display: none;
  }
  

    body {
        font-family: 'Inter', sans-serif;
    }

    .react-toggle {
  touch-action: pan-x;

  display: inline-block;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 0;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
}

.react-toggle-screenreader-only {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.react-toggle--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  -webkit-transition: opacity 0.25s;
  transition: opacity 0.25s;
}

.react-toggle-track {
  width: ${({ theme }) => theme.spacing(8)};
  height: ${({ theme }) => theme.spacing(4)};
  padding: 0;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.accent2};
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: ${({ theme }) => theme.color.accent2};
}

.react-toggle--checked .react-toggle-track {
  background-color: ${({ theme }) => theme.color.highlight};
}

.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: ${({ theme }) => lighten(0.1, theme.color.highlight)};
}

.react-toggle-track-check {
  position: absolute;
  width: 14px;
  height: 10px;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  left: ${({ theme }) => theme.spacing(1.5)};
  opacity: 0;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle--checked .react-toggle-track-check {
  opacity: 1;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle-track-x {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  right: ${({ theme }) => theme.spacing(1.5)};
  opacity: 1;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle--checked .react-toggle-track-x {
  opacity: 0;
}

.react-toggle-thumb {
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  position: absolute;
  top: 0px;
  left: 0px;
  width: ${({ theme }) => theme.spacing(4)};
  height:${({ theme }) => theme.spacing(4)};
  border: 1px solid ${({ theme }) => theme.color.accent3};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.base_contrast};

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.react-toggle--checked .react-toggle-thumb {
  left: ${({ theme }) => theme.spacing(4)};
  border-color: ${({ theme }) => theme.color.highlight};
}

.react-toggle--focus .react-toggle-thumb {
 /* -webkit-box-shadow: 0px 0px 3px 2px #0099E0;
  -moz-box-shadow: 0px 0px 3px 2px #0099E0;
  box-shadow: 0px 0px 2px 3px #0099E0;
  */
}

.react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
  /*
  -webkit-box-shadow: 0px 0px 5px 5px #0099E0;
  -moz-box-shadow: 0px 0px 5px 5px #0099E0;
  box-shadow: 0px 0px 5px 5px #0099E0;
  */
}



.react-datepicker-popper {
  z-index:1001
}
.react-datepicker-wrapper {
  flex: auto;

  input {
    width : 100%;
  }
}

.react-datepicker__header {
  background-color: ${({ theme }) => theme.color.highlight};
  border-bottom: none;
  color: white;
}

.react-datepicker__triangle {
  display: none;
}

.react-datepicker {
  font-family: inherit;
  border: none;
  box-shadow: 0px 4px 11px -3px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
}

.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {
  color: ${({ theme }) => theme.color.base_contrast};
}

.react-datepicker__navigation--previous {
    border-right-color: ${({ theme }) => theme.color.base_contrast};
}
.react-datepicker__navigation--next {
    border-left-color: ${({ theme }) => theme.color.base_contrast};
}

.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
  background-color: ${({ theme }) => theme.color.highlight};
  border-radius: 2px;
}

.react-datepicker__day--keyboard-selected:hover, .react-datepicker__month-text--keyboard-selected:hover, .react-datepicker__quarter-text--keyboard-selected:hover, .react-datepicker__year-text--keyboard-selected:hover {
  background-color: ${({ theme }) => lighten(0.1, theme.color.highlight)};
  border-radius: 2px;
}

.react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover {
  background-color: ${({ theme }) => theme.color.accent2};
  border-radius: 2px;
}

.react-datepicker-wrapper:hover input:not(:focus):not(::disabled) {
    border-color: ${({ theme }) => theme.color.accent3};
  }

  .weekselecter .react-datepicker__week:hover {
    .react-datepicker__day {
        background-color: ${({ theme }) => theme.color.highlight2};
        border-radius: 2px;
    }
  }

  .weekselecter .react-datepicker__week:has(.react-datepicker__day--selected) .react-datepicker__day:not(.react-datepicker__day--selected) {
    background-color: ${({ theme }) => theme.color.highlight2};
  }

  .react-datepicker__day--selected {
    background-color: ${({ theme }) => theme.color.highlight};
    border-radius: 2px;
  }

  .react-datepicker__week-number {
    color: ${({ theme }) => theme.color.accent2};
    border-radius: 1000px;
  }

  .react-datepicker__close-icon::after {
    background-color: transparent;
    font-size:24px;
    color: ${({ theme }) => theme.color.danger};
}


.swipeable-list {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.swipeable-list-item {
  position: relative;
  transition: max-height 0.5s ease;
  max-height: 1000px;
  transform-origin: top;
  overflow: hidden;
  width: 100%;
  z-index: 0;
}

.swipeable-list-item__content {
  width: 100%;
  align-items: center;
  box-sizing: border-box;
  background-color: ${({theme}) => theme.color.base_contrast};
  height: 100%;
  display: flex;
}

.swipeable-list-item__content--return {
  transition: transform 0.5s ease-out;
}
 
.swipeable-list-item__content--remove {
  transition: transform 0.35s ease-in;
}

.swipeable-list-item__content-right {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  opacity: 0;
}

.swipeable-list-item__content-right--return {
  transition: opacity 0.5s ease-out;
}

.swipeable-list-item__content-left {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  opacity: 0;
  justify-content: flex-end;
}

.swipeable-list-item__content-left--return {
  transition: opacity 0.5s ease-out;
}

[data-reach-dialog-content] {
  background-color: ${({theme}) => theme.color.base_contrast};
}

.highlight {
    background-color: ${(p) => p.theme.color.highlight2};
    padding: 0 1px;
    border-radius: 4px;
    }


    [data-reach-tooltip] {
        background-color: ${(p) => p.theme.color.base_contrast};
        border-radius: 4px;
    } 
`;
